/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const setMarketingOptOutLegacyGql = gql`
  mutation setMarketingOptOut($inviteCode: String!, $input: PublishablePostInput!) {
    setMarketingOptOut (path: $path, inviteCode: $inviteCode, input: $input) @rest(
      path: "invites/{args.inviteCode}/marketingOptOut",
      method: "POST"
    ) {
      NoResponse
    }
  }
`;

export const setMarketingOptOutWithCodeGql = gql`
  mutation setMarketingOptOutWithCode($inviteCode: String!, $optoutCode: String!, $input: PublishablePostInput!) {
    setMarketingOptOut (path: $path, inviteCode: $inviteCode, optoutCode: $optoutCode, input: $input) @rest(
      path: "invites/{args.inviteCode}/marketingOptOut/{args.optoutCode}",
      method: "POST"
    ) {
      NoResponse
    }
  }
`;
